"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureExpMemberWithPaginationSchema = exports.FeatureExpMemberSchema = exports.FeatureExpMemberRolesSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../user/schemas");
const schemas_2 = require("../schemas");
exports.FeatureExpMemberRolesSchema = zod_1.z.enum([
    'ACCOUNT_OWNER',
    'SUPER_ADMIN',
    'PROJECT_MANAGER',
    'MEMBER',
    'GUEST',
]);
exports.FeatureExpMemberSchema = zod_1.z.object({
    id: zod_1.z.string(),
    role: exports.FeatureExpMemberRolesSchema,
    user: schemas_1.FeatureExpUserSchema,
});
exports.FeatureExpMemberWithPaginationSchema = schemas_2.FeatureExpPaginationSchema.and(zod_1.z.object({
    items: zod_1.z.array(exports.FeatureExpMemberSchema),
}));
const FeatureExpMemberWithPaginationPayloadSchema = schemas_2.FeatureExpPaginationQueryParamSchema.and(zod_1.z.object({
    'search[user.emailOrName][]': zod_1.z.string().optional(),
}));
const ListFeatureExpMemberPropsSchema = zod_1.z.object({
    account_id: zod_1.z.string(),
    payload: FeatureExpMemberWithPaginationPayloadSchema.optional(),
});
const BatchPostFeatureExpMemberPropsSchema = zod_1.z.object({
    account_id: zod_1.z.string(),
    users: zod_1.z.array(zod_1.z.object({
        email: zod_1.z.string(),
        role: exports.FeatureExpMemberRolesSchema,
    })),
});
const PatchFeatureExpMemberPropsSchema = zod_1.z.object({
    account_id: zod_1.z.string(),
    member_id: zod_1.z.string(),
    role: exports.FeatureExpMemberRolesSchema,
});
const BatchRemoveFeatureExpMemberPropsSchema = zod_1.z.object({
    account_id: zod_1.z.string(),
    usersIds: zod_1.z.array(zod_1.z.string()),
});
//# sourceMappingURL=schemas.js.map